module.exports = {
    Polygon : require("./Polygon"),
    Point : require("./Point"),
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/p2/~/poly-decomp/src/index.js
 ** module id = 195
 ** module chunks = 1
 **/